<div class="collapsible-row">
  <table class="collapsible-table" aria-describedby="collapsible-row">
    <tr class="table-row" *ngIf="meterData">
      <td class="table-cell meter-type" *ngIf="meterData.meterTypeCode">
        <app-svg-icon
          class="table-icon"
          src="./assets/icons/{{ getMeterTypeImage(meterData.meterTypeCode, meterData.deviceId) }}"
          title="{{ meterData.deviceId === null ? meterData.meterTypesName : ('module.meterReading.remoteName' | translate) }}"
        ></app-svg-icon>
      </td>
      <td class="table-cell energy-type" [ngClass]="{ remote: !!meterData.deviceId }" *ngIf="meterData.energyTypesName">
        <img
          alt="energy-type-img"
          class="table-icon"
          src="./assets/icons/{{ getEnergyTypeImage(meterData.energyTypesName) }}"
          title="{{ meterData.energyTypesName }}"
        />
      </td>
      <td class="table-cell address">{{ meterData | getAddress }}</td>
      <td class="table-cell object">
        <ng-container *ngIf="meterData.objectType; else displayNullObjectType">
          {{ meterData.objectType }}
        </ng-container>
        <ng-template #displayNullObjectType>
          <app-svg-icon
            matTooltip=" {{ 'module.meterReading.objectHoverMessage' | translate }}"
            matTooltipPosition="above"
            matTooltipClass="object-hover-message"
            class="icon-info"
            src="./assets/icons/ep_info_icon.svg"
          ></app-svg-icon>
          <span class="object-null-text">{{ 'module.meterReading.objectTypeIsNull' | translate }}</span>
        </ng-template>
      </td>
      <td class="table-cell notes">
        <app-note-pop-up
          [value]="meterData.notes"
          class="note-pop-up-component"
          [(updateSuccess)]="meterData.isNoteUpdateSuccess"
          [canEdit]="!!authService.permissions.METER_READING_NOTES_UPDATE"
          [placeholder]="'Notiz einfügen'"
          (saveEvent)="saveNotes(meterData.guid, $event, meterData)"
        ></app-note-pop-up>
      </td>
      <td class="table-cell meter-number">
        <div class="meter-sensor-number">
          <div *ngIf="meterData.meterNumber">Z: {{ meterData.meterNumber }}</div>
          <div *ngIf="meterData.marketLocationKey" class="malo-row">M: {{ meterData.getMarketLocationKeyWithOutLeadingZeros() }}</div>
          <div *ngIf="meterData.deviceId && !!authService.permissions.SENSOR_DATA">S: {{ meterData.getSensorNumberWithOutLeadingZeros() }}</div>
        </div>
        <div class="direction">
          <span *ngIf="meterData.isProducer()" title="{{ 'module.meterReading.isProducer' | translate }}" class="fa fa-arrow-up"></span>
          <span *ngIf="meterData.isConsumer()" title="{{ 'module.meterReading.isConsumer' | translate }}" class="fa fa-arrow-down"></span>
        </div>
      </td>
      <td class="table-cell energy-guard" *ngIf="!!authService.permissions.ENERGY_GUARD && isMunicipalityLicensed">
        <app-shield-guard-icon
          *ngIf="energyGuardData !== null"
          class="energy-guard-icon"
          [isMeterLicensed]="meterData.meterAlarm.isEnergyGuardLicenseAvailable"
          [alarmCount]="meterData.meterAlarm.count"
          [badgeVisible]="meterData.meterAlarm.count > 0"
          [isIconForHomeScreen]="false"
          [isIconForDetail]="true"
        >
        </app-shield-guard-icon>
        <span *ngIf="energyGuardData === null" class="loader fa fa-spinner fa-spin fa-3x"></span>
      </td>
      <td class="table-cell graph link" *ngIf="!!authService.permissions.ENERGY_DATA">
        <a (click)="navigateToConsumptionPage(meterData.guid)"
          ><span class="fa fa-bar-chart" aria-hidden="true"></span> {{ 'module.meterReading.seeDetailsCollapsibleRowNavText' | translate }}</a
        >
      </td>
    </tr>
  </table>
</div>
